import React from 'react';
import AgentRing from './AgentRing';
import { AGENTS, getActiveAgent, getCompletedCount } from '../context/AgentContext';

const STATUS_DOT_COLORS = {
  completed: '#10b981',
  running: '#3b82f6',
  failed: '#ef4444',
  pending: '#4b5563',
};

const PRIORITY_COLORS = {
  high: '#ef4444',
  medium: '#f59e0b',
  low: '#6b7280',
};

const TaskCard = ({ task, onClick }) => {
  const activeAgent = getActiveAgent(task);
  const completedCount = getCompletedCount(task);
  const isActive = !!activeAgent;
  const allDone = completedCount === 4;

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    if (diff < 60) return 'now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    return `${Math.floor(diff / 86400)}d`;
  };

  return (
    <div
      className={`task-card ${isActive ? 'task-card--active' : ''} ${allDone ? 'task-card--done' : ''}`}
      onClick={onClick}
    >
      {/* Header */}
      <div className="task-card__header">
        <span className="task-card__id">TH-{task.id}</span>
        <span className="task-card__time">{formatTime(task.updated_at)}</span>
      </div>

      {/* Title */}
      <div className="task-card__title">{task.title}</div>

      {/* Center: Agent Ring */}
      <div className="task-card__ring">
        <AgentRing pipeline={task.pipeline} size={80} />
      </div>

      {/* Bottom: Agent Dots + Priority */}
      <div className="task-card__footer">
        <div className="task-card__dots">
          {AGENTS.map((agent) => {
            const status = task.pipeline?.[agent.id]?.status || 'pending';
            const color = STATUS_DOT_COLORS[status];
            return (
              <div
                key={agent.id}
                className={`task-card__dot ${status === 'running' ? 'task-card__dot--running' : ''}`}
                style={{ background: color }}
                title={`${agent.label}: ${status}`}
              >
                <span className="task-card__dot-label">{agent.label[0]}</span>
              </div>
            );
          })}
        </div>
        <span
          className="task-card__priority"
          style={{ color: PRIORITY_COLORS[task.priority] || '#6b7280' }}
        >
          {task.priority}
        </span>
      </div>
    </div>
  );
};

export default TaskCard;
